<template>
    <div style="text-align: center; padding: 4rem;">
        <h2>404 - Página não encontrada</h2>
    </div>
</template>

<script>
	export default { name: "NotFound" };
</script>